/**
 * Supabase Client - Browser-side client for Supabase operations
 * Part of Story 1.1: Supabase Integration Setup
 * 
 * This client is used for browser-side operations and includes basic authentication.
 * For server-side operations with full auth validation, use server.ts
 */

import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/supabase'

// Validate environment variables
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

if (!supabaseUrl) {
  console.warn('[Supabase Client] Missing env.NEXT_PUBLIC_SUPABASE_URL - Supabase client will not be functional')
}

if (!supabaseAnonKey) {
  console.warn('[Supabase Client] Missing env.NEXT_PUBLIC_SUPABASE_ANON_KEY - Supabase client will not be functional')
}

// Create and export the Supabase client (will be null if env vars missing)
export const supabase = (supabaseUrl && supabaseAnonKey) ? createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'supabase.auth.token',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'X-Client-Info': 'eskweb-unified@0.2.0',
    },
  },
}) : null

// Helper function to check if we're in browser environment
export const isBrowser = typeof window !== 'undefined'

// Export types for convenience
export type { Database } from '@/types/supabase'